var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Nav-Tray",
    transform: "translate(-873.000000, -162.000000)",
    fill: "#A28C62",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Tray",
    transform: "translate(853.000000, -61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "services"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0 C7.22942354,0 2.94113159,4.28829194 2.94113159,9.55886841 L2.94113159,18.3822632 C2.94113159,19.5987701 3.93066406,20.5883026 5.14698027,20.5883026 C6.36348726,20.5883026 7.35301973,19.5987701 7.35301973,18.3822632 L7.35301973,11.0294342 C7.35301973,9.81311797 6.36348726,8.8235855 5.14698027,8.8235855 C4.89940645,8.8235855 4.66518403,8.87374878 4.44259644,8.94927979 C4.75635527,4.77390288 8.24642183,1.47056582 12.5,1.47056582 C16.7512894,1.47056582 20.2404022,4.77085112 20.5570221,8.94336699 C20.3357696,8.86764526 20.1002121,8.8235855 19.8530197,8.8235855 C18.6365127,8.8235855 17.6469803,9.81311797 17.6469803,11.0294342 L17.6469803,18.3822632 C17.6469803,19.5987701 18.6365127,20.5883026 19.8530197,20.5883026 C20.1120376,20.5883026 20.3571319,20.5352783 20.5883026,20.4528809 L20.5883026,21.3235855 C20.5883026,21.7292786 20.2579498,22.0588684 19.8530197,22.0588684 L14.570427,22.0588684 C14.2658233,21.2047577 13.4572983,20.5883026 12.5,20.5883026 C11.2836838,20.5883026 10.2941513,21.5778351 10.2941513,22.7941513 C10.2941513,24.0104675 11.2836838,25 12.5,25 C13.4572983,25 14.2658233,24.3833542 14.570427,23.5294342 L19.8530197,23.5294342 C21.0693359,23.5294342 22.0588684,22.5399018 22.0588684,21.3235855 C22.0588684,16.9008255 22.0588684,13.9863968 22.0588684,9.55886841 C22.0588684,4.28829194 17.7705765,0 12.5,0 L12.5,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5294342,10.429573 L23.5294342,18.9821243 C24.3833542,18.6777115 25,17.8691864 25,16.9116974 L25,12.5 C25,11.5427017 24.3833542,10.7341767 23.5294342,10.429573 L23.5294342,10.429573 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.5 L0,16.9116974 C0,17.8691864 0.616645801,18.6777115 1.47056582,18.9821243 L1.47056582,10.429573 C0.616645801,10.7341767 0,11.5427017 0,12.5 Z",
    id: "Path"
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.b1bbe77d72e0f9d74733297e287be2dd.svg";
export { ForwardRef as ReactComponent };